import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { VERTICAL_EMBED_TYPE } from "../types.js";
import { VerticalEmbedViewer } from "./vertical-embed-viewer.js";
const VerticalEmbed = ({ node, nodeIndex, NodeViewContainer }) => {
  const { helpers, config } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex }, /* @__PURE__ */ React.createElement(
    VerticalEmbedViewer,
    {
      nodeId: node.id,
      settings: config[VERTICAL_EMBED_TYPE] || {},
      componentData: node.appEmbedData,
      helpers
    }
  ));
};
var verticalEmbed_default = VerticalEmbed;
export {
  verticalEmbed_default as default
};
//# sourceMappingURL=verticalEmbed.js.map

import "@wix/ricos/css/plugin-vertical-embed-viewer.global.css";